import { BlockParams, BlockType } from "@/types/blockTypes";

export class Block {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  title: string;
  type: BlockType;
  orgId: string;
  /** The block's org (its "orgId" column), under the name containers and other org-owned rows use. */
  propelOrgId: string;

  constructor(params: BlockParams) {
    this.id = params.id;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.title = params.title || '';
    this.type = params.type;
    this.orgId = params.orgId;
    this.propelOrgId = params.orgId;
  }
}
